import DeXParaMaterial from '@/pages/dexpara/Material'
import DeXParaMetodo from '@/pages/dexpara/Metodo'
import DeXParaOrdem from '@/pages/dexpara/Ordem'
import DeXParaResultado from '@/pages/dexpara/Resultado'
import DeXParaComplement from '@/pages/dexpara/Complement'
import DeXParaExameResultado from '@/pages/dexpara/ExameResultado'
import DeXParaTipo from '@/pages/dexpara/Tipo'
import TipoIndex from '@/pages/dexpara/Tipo/Index'
import TipoForm from '@/pages/dexpara/Tipo/Form'
import TipoValueForm from '@/pages/dexpara/Tipo/ValueForm'
import ResultRangeIndex from '@/pages/dexpara/ResultRange/Index'
import ResultRangeForm from '@/pages/dexpara/ResultRange/Form'
import ResultConversionIndex from '@/pages/dexpara/ResultConversion/Index'
import ResultConversionForm from '@/pages/dexpara/ResultConversion/Form'

const DeXParaRoutes = [
    {path: '/deXpara/material', name: 'dexpara.material', component: DeXParaMaterial, meta: {permission: 'dexpara.material'}},
    {path: '/deXpara/complement', name: 'dexpara.complement', component: DeXParaComplement, meta: {permission: 'dexpara.complement'}},
    {path: '/deXpara/metodo', name: 'dexpara.metodo', component: DeXParaMetodo, meta: {permission: 'dexpara.metodo'}},
    {path: '/deXpara/ordem', name: 'dexpara.ordem', component: DeXParaOrdem, meta: {permission: 'dexpara.ordem'}},
    {path: '/deXpara/resultado', name: 'dexpara.resultado', component: DeXParaResultado, meta: {permission: 'dexpara.resultado'}},
    {path: '/deXpara/exame-resultado', name: 'dexpara.exame.resultado', component: DeXParaExameResultado, meta: {permission: 'dexpara.exame.resultado'}},
    {path: '/deXpara/tipo', name: 'dexpara.tipo', component: DeXParaTipo, meta: {permission: 'dexpara.tipo'}},

    {path: '/tipo', name: 'tipo', component: TipoIndex, meta: {permission: 'tipo'}},
    {path: '/tipo/create', name: 'tipo.create', component: TipoForm, meta: {permission: 'tipo.create'}},
    {path: '/tipo/edit/:id', name: 'tipo.edit', component: TipoForm, meta: {permission: 'tipo.edit'}},
    {path: '/tipo/value/create/:tipo_id', name: 'tipo.value.create', component: TipoValueForm, meta: {permission: 'tipo.value.create'}},
    {path: '/tipo/value/edit/:id', name: 'tipo.value.edit', component: TipoValueForm, meta: {permission: 'tipo.value.edit'}},

    {path: '/deXpara/resultrange', name: 'resultrange', component: ResultRangeIndex, meta: {permission: 'resultrange'}},
    {path: '/deXpara/resultrange/create', name: 'resultrange.create', component: ResultRangeForm, meta: {permission: 'resultrange.create'}},
    {path: '/deXpara/resultrange/edit/:id', name: 'resultrange.edit', component: ResultRangeForm, meta: {permission: 'resultrange.edit'}},

    {path: '/deXpara/resultconversion', name: 'resultconversion', component: ResultConversionIndex, meta: {permission: 'resultconversion'}},
    {path: '/deXpara/resultconversion/create', name: 'resultconversion.create', component: ResultConversionForm, meta: {permission: 'resultconversion.create'}},
    {path: '/deXpara/resultconversion/edit/:id', name: 'resultconversion.edit', component: ResultConversionForm, meta: {permission: 'resultconversion.edit'}},

];

export default DeXParaRoutes;